import { TableSortLabel } from '@cambridgeassessment/cambridge-ui';
import React, { memo } from 'react';
import { TooltipContent } from 'src/types';
import HeadLabel from './TableHeadLabel';
import { Order } from './types';

type Props = {
  order: Order;
  active: boolean;
  description?: TooltipContent['key'];
  label: string;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

const TableHeadLabel: React.FC<Props> = ({
  order,
  label,
  description,
  active,
  onClick,
}) => (
  <TableSortLabel
    active={active}
    direction={order === Order.Asc ? 'asc' : 'desc'}
    onClick={onClick}
    data-testid="sorting-head-label"
  >
    <HeadLabel description={description} label={label} />
  </TableSortLabel>
);

export default memo(TableHeadLabel);
